module.exports = __webpack_public_path__ + "static/media/backsh.5ea5c59f.png";